import React, { useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "./firebase";
import { motion } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AiOutlineLoading3Quarters,
  AiOutlineCheckCircle,
  AiOutlineWarning,
  AiOutlineUser,
  AiOutlineLock,
} from "react-icons/ai";

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isNewUser, setIsNewUser] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLoginOrRegister = async () => {
    const email = `${username}@gmail.com`; // Simple transformation for demo purposes
    setLoading(true);
    try {
      if (isNewUser) {
        await createUserWithEmailAndPassword(auth, email, password);
        toast.success("Account created successfully!", {
          icon: <AiOutlineCheckCircle />,
        });
      } else {
        await signInWithEmailAndPassword(auth, email, password);
        toast.success("Logged in successfully!", {
          icon: <AiOutlineCheckCircle />,
        });
      }
      onLogin(username);
    } catch (error) {
      toast.error(`Error: ${error.message}`, { icon: <AiOutlineWarning /> });
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-200 via-blue-100 to-blue-300 relative px-4 py-6"
      style={{
        backgroundImage: `url('https://www.transparenttextures.com/patterns/diamond-upholstery.png')`,
        backgroundBlendMode: "overlay",
      }}
    >
      <ToastContainer />
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8 z-10">
        <div className="flex flex-col items-center mb-6">
          <img
            src="/file nest.svg"
            alt="FileNest Logo"
            className="w-24 h-24 mb-4"
          />
          <h1 className="text-2xl font-bold text-gray-800">
            {isNewUser ? "Create your account" : "Welcome Back to FileNest"}
          </h1>
          <p className="text-gray-500 text-sm text-center mt-2">
            {isNewUser
              ? "Sign up to securely share and manage your files."
              : "Log in to access your account and shared files."}
          </p>
        </div>

        <div className="space-y-4">
          <div className="relative">
            <AiOutlineUser className="absolute left-3 top-3 text-gray-400" />
            <input
              id="username"
              type="text"
              placeholder="Enter your username"
              className="w-full pl-10 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="relative">
            <AiOutlineLock className="absolute left-3 top-3 text-gray-400" />
            <input
              id="password"
              type="password"
              placeholder="Enter your password"
              className="w-full pl-10 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </div>

        <button
          onClick={handleLoginOrRegister}
          className="w-full mt-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow hover:bg-blue-700 transition flex items-center justify-center"
          disabled={loading}
        >
          {loading ? (
            <AiOutlineLoading3Quarters className="animate-spin mr-2" />
          ) : null}
          {isNewUser ? "Sign up" : "Sign in"}
        </button>

        <div className="mt-6 flex items-center">
          <div className="flex-1 h-px bg-gray-300"></div>
          <span className="mx-3 text-sm text-gray-500">OR</span>
          <div className="flex-1 h-px bg-gray-300"></div>
        </div>

        <p className="text-sm text-center text-gray-500 mt-4">
          {isNewUser ? "Already have an account?" : "Don't have an account?"}{" "}
          <span
            onClick={() => setIsNewUser(!isNewUser)}
            className="text-blue-600 font-medium cursor-pointer hover:underline"
          >
            {isNewUser ? "Sign in" : "Sign up"}
          </span>
        </p>
      </div>

      <footer className="mt-6 text-center text-gray-500 text-sm absolute bottom-4">
        Developed by Suvm<span className="text-red-500">.</span>
      </footer>
    </motion.div>
  );
};

export default Login;
